export const LOCAL_STORAGE_KEY = "__activity_tracker_logout_time__";
export const FAST_LOGOUT_KEY = "__activity_tracker_fast_logout__";
